import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import { contextFormulario } from './PrincipalFormulario';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import CondicionOpcion from './CondicionOpcion';
import UtilsBufer from '../Tools/UtilsBufer';
const server = process.env.REACT_APP_SERVER
function GenPregunta(props) {
    const { refresh, preguntas, itemSelect } = props;
    const { selectItem, regional } = useContext(contextFormulario);
    const [idPregunta, setIdPregunta] = useState(0);
    const [tipo, setTipo] = useState('');
    const [pregunta, setPregunta] = useState('');
    const [opciones, setOpciones] = useState([]);
    const [nombreOpt, setNombreOpt] = useState('');
    const [idAdjunto, setIdAdjunto] = useState(0);
    const [nombreImg, setNombreImg] = useState('');
    const [obligatorio, setObligatorio] = useState(false);
    const [idAlcance, setIdAlcance] = useState(-1);
    const [alcanceValor, setAlcanceValor] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [tipoAlcance, setTipoAlcance] = useState(0);
    const [optElegido, setOptElegido] = useState({});
    const [completo, setCompleto] = useState(false);
    function ordenarOpciones(datos) {
        datos.sort(function (a, b) {
            if (a.DESCRIPCION < b.DESCRIPCION) {
                return -1
            } else if (a.DESCRIPCION > b.DESCRIPCION) {
                return 1
            } else {
                return 0
            }
        })
        return datos;
    }
    const guardarOpcion = () => {
        if (nombreOpt != '') {
            /*setOpciones(ordenarOpciones([...opciones, 
                { "DESCRIPCION": nombreOpt, "ID_OPCION": 0, "ID_ALCANCE": 0,"CONDICION":'-1|0' ,
                "ALCANCE_VALOR": [{ "ID_ALCANCE": 0, "VALOR": regional, "DESCRIPCION": regional=='990'?"CBBA":"SCZ" }] }]));*/
            setOpciones([...opciones,
            {
                "DESCRIPCION": nombreOpt, "ID_OPCION": 0, "ID_ALCANCE": 0, "CONDICION": '-1|0',
                "ALCANCE_VALOR": [{ "ID_ALCANCE": 0, "VALOR": regional, "DESCRIPCION": regional == '990' ? "CBBA" : "SCZ" }]
            }]);
            setNombreOpt('');
        } else {
            MsgUtils.msgError("No se permite Nombre Vacio !!")
        }
    }
    function validarCampos() {
        if (pregunta !== '' && tipo !== '' && idAlcance !== -1) {
            return true;
        } else {
            return false;
        }
    }
    const guardarPregunta = () => {
        if (validarCampos()) {
            fetch(`${server}/formulario/savePregunta`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, idPregunta, pregunta, tipo, obligatorio, opciones, idAdjunto, selectItem, idAlcance, alcanceValor
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setIdPregunta(0);
                        setPregunta('');
                        setTipo('');
                        setOpciones([]);
                        setIdAdjunto(0);
                        setNombreImg('');
                        setObligatorio(false);
                        setIdAlcance(0);
                        setAlcanceValor([]);
                        refresh();
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            MsgUtils.msgError("No se Permite Campos Vacios");
        }
    }
    const eliminarOpcion = (dato) => {
        if (dato.ID_OPCION === 0) {
            var listaAux = opciones.filter((item) => item.DESCRIPCION !== dato.DESCRIPCION)
            setOpciones(ordenarOpciones(listaAux));
        } else {
            fetch(`${server}/formulario/deleteOpcion`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    regional, ...dato
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        console.log(data.ok);
                    } else {
                        MsgUtils.msgError(data.error);
                    }
                })
                .catch(err => MsgUtils.msgError(err));
        }
    }
    const eliminarFoto = (dato, id) => {
        fetch(`${server}/formulario/eliminarImagen`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, ID_ADJUNTO: id === null ? dato.ID_ADJUNTO : id
            })
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.ok) {
                    if (id === null) {
                        var lista = opciones.filter((item) => item.DESCRIPCION !== dato.DESCRIPCION)
                        var aux = dato;
                        aux.ID_ADJUNTO = null;
                        aux.NOMBRE_IMG = undefined;
                        setOpciones(ordenarOpciones([...lista, aux]));
                    } else {
                        setNombreImg('');
                        setIdAdjunto(0);
                    }
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }
    const cargarFoto = (e, d) => {
        var archiv = e.target.files[0];
        if (archiv.size / 1000000 < 3.5) {
            var info = JSON.parse(localStorage.getItem('__react_session__'));
            var formData = new FormData()
            formData.append('FILE1', new Blob([archiv], { contentType: 'application/octet-stream', contentTransferEncoding: 'binary' }), archiv.name + "." + info.regional + "." + info.idSession);
            try {
                axios.post(`${server}/formulario/cargarImagen`, formData, {
                    'Accept': 'application/json',
                    'content-type': 'multipart/form-data'
                }).then(res => {
                    var id = res.data.ok.V_ID;
                    var nombre = archiv.name.split('.')
                    if (d === null) {
                        setNombreImg('ADJUNTO_ENC_' + id + '.' + nombre[nombre.length - 1])
                        setIdAdjunto(id)
                    } else {
                        var aux = opciones.filter((item) => item.DESCRIPCION !== d.DESCRIPCION)
                        var auxf = d
                        auxf.NOMBRE_IMG = 'ADJUNTO_ENC_' + id + '.' + nombre[nombre.length - 1];
                        auxf.ID_ADJUNTO = id;
                        setOpciones(ordenarOpciones([...aux, auxf]));
                    }
                }).catch(error => {
                    MsgUtils.msgError(JSON.parse(error.request.response).error);
                })
            } catch (error) {
                MsgUtils.msgError(error.message);
                console.error('Error al subir el archivo !!');
            }
        } else {
            MsgUtils.msgError("Coloque Imagen < 3.5 Megas")
        }
    }
    const cambiarAlcance = (valor, tipo) => {
        setTipoAlcance(tipo);
        if (tipo === 0) {
            setIdAlcance(valor);
            if (valor == 1) {
                setModalShow(true);
            } else {
                setAlcanceValor([{ "ID_ALCANCE": idAlcance, "VALOR": regional, "DESCRIPCION": regional == '990' ? "CBBA" : "SCZ" }]);
            }
        } else {
            var aux = opciones.filter((item) => item.DESCRIPCION == tipo.DESCRIPCION)[0];
            aux.ID_ALCANCE = valor;
            if (valor == 0) {
                aux.ALCANCE_VALOR = [{ "ID_ALCANCE": valor, "VALOR": regional, "DESCRIPCION": regional == '990' ? "CBBA" : "SCZ" }];
            }
            var opcionesAux = [...opciones.filter((item) => item.DESCRIPCION != tipo.DESCRIPCION), aux];
            setOpciones(ordenarOpciones(opcionesAux));
            if (valor == 1) {
                setOptElegido(tipo);
                setModalShow(true);
            }
        }
    }
    const guardarAlcance = (valor) => {
        var suc = sucursales.filter((item) => item.ID_SUCURSAL == valor)[0];
        if (tipoAlcance === 0) {
            setAlcanceValor([{ "ID_ALCANCE": idAlcance, "VALOR": valor, 'DESCRIPCION': suc.SUCURSAL }])
        } else {
            console.log(suc);
            var aux = opciones.filter((item) => item.DESCRIPCION === optElegido.DESCRIPCION)[0];
            aux.ALCANCE_VALOR = [{ "ID_ALCANCE": aux.ID_ALCANCE, "VALOR": valor, "DESCRIPCION": suc.SUCURSAL }];
            var opcionesAux = [...opciones.filter((item) => item.DESCRIPCION != optElegido.DESCRIPCION), aux]
            setOpciones(ordenarOpciones(opcionesAux));
            setOptElegido({});
            console.log("otro")
        }
        setModalShow(false);
    }
    const cambiarCondicion = (cd, dato, cds) => {
        var aux = opciones.filter((item) => item.DESCRIPCION === dato.DESCRIPCION)[0];
        aux.CONDICION = cd + '|' + cds;
        var opcionesAux = [...opciones.filter((item) => item.DESCRIPCION != dato.DESCRIPCION), aux]
        setOpciones(ordenarOpciones(opcionesAux));
    }
    useEffect(() => {
        fetch(`${server}/sqlComun/sucursalofi`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    setSucursales(data.ok);
                } else {
                    MsgUtils.msgError(data.error);
                }
            })
            .catch(err => MsgUtils.msgError(err));
    }, [])
    useEffect(() => {
        if (itemSelect.ID_PREGUNTA !== undefined) {
            console.log(itemSelect);
            setIdPregunta(itemSelect.ID_PREGUNTA);
            setTipo(itemSelect.TIPO);
            setPregunta(UtilsBufer.getText(itemSelect.DESCRIPCION));
            var aux = itemSelect.OPCIONES;
            for (var i = 0; i < aux.length; i++) {
                aux[i].DESCRIPCION = UtilsBufer.getText(aux[i].DESCRIPCION);
                aux[i].NOMBRE_IMG = aux[i].NOMBRE;
            }
            setOpciones(ordenarOpciones(aux));
            setIdAdjunto(itemSelect.ID_ADJUNTO);
            if (itemSelect.NOMBRE !== null) {
                setNombreImg(itemSelect.NOMBRE)
            } else {
                setNombreImg('');
            }
            setObligatorio(itemSelect.OBLIGATORIO == 'S' ? true : false);
            setIdAlcance(itemSelect.ID_ALCANCE);
            setAlcanceValor(itemSelect.ALCANCE_VALOR);
            setCompleto(true);
        } else {
            setCompleto(true);
        }
    }, [itemSelect])
    return (
        <>
            {completo && <div className='card '>
                <div className='card-header bg-dark bg-gradient'>
                    <div className='row row-cols-2 row-cols-md-3 g-1'>
                        <div className='col-4 col-md-3'>
                            <input type="text" className="form-control form-control-sm w-100"
                                placeholder="Pregunta ? " value={pregunta} 
                                onChange={(e) => setPregunta(e.target.value)} />
                        </div>
                        <div className='col-2 text-center'>
                            <label className='btn btn-sm m-0 p-0 text-success'
                                title='Subir una foto para la pregunta' >
                                <i className="fa-solid fa-image fa-2xl"></i>
                                <input type="file" accept='image/*' onChange={(e) => cargarFoto(e, null)} />
                            </label>
                        </div>
                        <div className='col-4 col-md-3'>
                            <select className="form-select form-select-sm" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                                <option value=''>Tipo de Pregunta ...</option>
                                <option value="R">Respuesta Escrita</option>
                                <option value="S"> Selección </option>
                                <option value="M"> Selección Multiple</option>
                                <option value="O">Opcion Respuestas</option>
                                <option value="F"> Fecha</option>
                                <option value="H"> Hora</option>
                            </select>
                        </div>
                        <div className='col-6 col-md-2 my-auto'>
                            <div className="form-check">
                                <input className="form-check-input " type="checkbox" defaultChecked={obligatorio}
                                    onChange={() => setObligatorio(!obligatorio)} />
                                <label className="form-check-label text-light" >Obligatorio?</label>
                            </div>
                        </div>
                        <div className='col-4 col-md-2'>
                            <select className="form-select form-select-sm" value={idAlcance} onChange={(e) => cambiarAlcance(e.target.value, 0)}>
                                <option value={-1}>Alcance?</option>
                                <option value={0}> Todos </option>
                                <option value={1}> Solo Sucursal </option>
                            </select>
                        </div>
                    </div>
                </div>
                {nombreImg !== '' &&
                    <div className='position-relative mx-auto' style={{ width: "200px" }}>
                        <img src={`${server}/imagenes/${nombreImg}`} className="card-img-top  ">
                        </img>
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger btn"
                            onClick={() => eliminarFoto(null, idAdjunto)}>
                            X
                        </span>
                    </div>
                }
                <div className='card-boby'>
                    <div className='py-2'>
                        {tipo === 'R' &&
                            <input type="text" className="form-control form-control-sm" placeholder="Responde aqui ..." />
                        }
                        {(tipo === 'S' || tipo === 'M'||tipo==='O') &&
                            <div className='container-fluid'>
                                <div className="input-group input-group-sm " style={{ width: "200px" }}>
                                    <input type="text" className="form-control form-control-sm"
                                        placeholder="Opcion ?" value={nombreOpt} onChange={(e) => setNombreOpt(e.target.value.toUpperCase())} />
                                    <button className="btn btn-sm btn-success"
                                        onClick={() => guardarOpcion()}>
                                        <i className="fa-solid fa-circle-plus"></i>
                                    </button>
                                </div>
                                <div className='py-2'>
                                    {opciones.map((item, index) => {
                                        return (
                                            <div className="form-check py-2 border" key={index}>
                                                {tipo!='O'&&<input className="form-check-input" type="radio" />}
                                                {tipo=='O'&&<input className="form-check-input" type="radio" checked />}
                                                <div className='container-fluid '>
                                                    <div className='row'>
                                                        {item.NOMBRE_IMG !== undefined && item.NOMBRE_IMG!==''&& item.NOMBRE_IMG!==null &&
                                                            <div className='col col-sm-1'>
                                                                <div className='position-relative' style={{ width: "50px" }}>
                                                                    <img src={`${server}/imagenes/${item.NOMBRE_IMG}`} className="img-fluid">
                                                                    </img>
                                                                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger btn"
                                                                        onClick={() => eliminarFoto(item, null)}>
                                                                        X
                                                                    </span>
                                                                </div>
                                                            </div>}
                                                        <div className='col col-sm-3'>
                                                            <label className="form-check-label" >
                                                                {item.DESCRIPCION}
                                                            </label>
                                                            <button className='btn btn-sm m-0 p-0 px-2 text-danger' 
                                                                title='Eliminar esta opción'
                                                                onClick={() => eliminarOpcion(item)}>
                                                                <i className="fa-solid fa-trash-can fa-xl"></i>
                                                            </button>
                                                            <label className='btn btn-sm m-0 p-0 text-success'
                                                                title='Colocar un foto descriptiva'>
                                                                <i className="fa-solid fa-image fa-xl"></i>
                                                                <input type="file" accept='image/*' 
                                                                onChange={(e) => cargarFoto(e, item)} />
                                                            </label>
                                                        </div>
                                                        <div className='col '>
                                                            <div className='btn-group btn-group-sm'>
                                                                <span>Para: </span>
                                                                <select className="form-select form-select-sm mx-2" style={{ width: '100px' }}
                                                                    value={item.ID_ALCANCE} onChange={(e) => cambiarAlcance(e.target.value, item)}>
                                                                    <option value={-1}>Alcance?</option>
                                                                    <option value={0}> Todos </option>
                                                                    <option value={1}> Solo Sucursal </option>
                                                                </select>
                                                                <button className='btn btn-sm btn-secondary' data-bs-toggle="collapse"
                                                                    data-bs-target={`#${item.DESCRIPCION.replace(/\s+/g, '').replace(/[^a-zA-Z0-9 ]/g, "")}`} 
                                                                    aria-expanded="false" 
                                                                    title="colocar una condición si elijen esta opción"
                                                                    aria-controls={`${item.DESCRIPCION.replace(/\s+/g, '').replace(/[^a-zA-Z0-9 ]/g, "")}`}>
                                                                    Condición <i className="fa-solid fa-arrows-split-up-and-left"></i>
                                                                </button>
                                                            </div>
                                                            <div className="alert alert-success m-0 p-0" role="alert">
                                                                {item.ALCANCE_VALOR[0].DESCRIPCION}
                                                            </div>
                                                            <div className='collapse border' id={`${item.DESCRIPCION.replace(/\s+/g, '').replace(/[^a-zA-Z0-9 ]/g, "")}`}>
                                                                <CondicionOpcion preguntas={preguntas} info={item} cambiarCondicion={cambiarCondicion} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {tipo=='O'&&<input className='form-control form-control-sm' placeholder='Responde Aqui...' disabled></input>}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        }
                        {tipo === 'F' &&
                            <div className='container-fluid'>
                                <span>Fecha: </span>
                                <input type="date" className="form-control form-control-sm" style={{ width: '200px' }} />
                            </div>}
                        {tipo === 'H' &&
                            <div className='container-fluid'>
                                <span>Hora: </span>
                                <input type="time" className="form-control form-control-sm" style={{ width: '200px' }} />
                            </div>}
                    </div>
                </div>
                <div className='card-footer text-end'>
                    <button className='btn btn-sm btn-success bg-gradient' onClick={() => guardarPregunta()}>
                        <i className="fa-solid fa-floppy-disk fa-xl"></i> Guardar
                    </button>
                </div>
                <Modal show={modalShow} onHide={() => setModalShow(false)}
                    size="sm"
                    aria-labelledby="contained-modal-title-vcenter"
                    contentClassName='bg-dark bg-gradient'>
                    <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                        <Modal.Title>
                            <div className='text-light'>Elija la Sucursal</div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body bsPrefix='modal-body m-0 p-0'>
                        <div className='text-center container-fluid'>
                            <select className="form-select form-select-sm"
                                onChange={(e) => guardarAlcance(e.target.value)}>
                                <option value={-1}>Ninguno</option>
                                {sucursales.map((item, index) => {
                                    return (
                                        <option value={item.ID_SUCURSAL} key={index} >
                                            {item.SUCURSAL + ' [' + item.TIPO + ']'}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>}
        </>
    )
}

export default GenPregunta
